<template>
  <card shadow type="secondary" class="text-center">
    <div class="card-profile-image">
      <img
        v-if="startup.logo"
        :src="startup.logo.url"
        class="card-image my-3"
        alt="..."
      />
    </div>
    <div class="card-body mt-9 py-0">
      <div>
        <h2 class="card-title text-orange mb-1">
          {{ startup.name }}
        </h2>
        <div>
          <div class="h5 font-weight-300 mb-1">
            <i class="ni ni-pin-3 mr-2"></i>{{ startup.city || "..." }},
            {{ startup.state || "..." }}
          </div>
        </div>
        <div class="col-12 text-sm mt-3">
          <i class="fas fa-quote-left mr-1"></i>{{ startup.one_sentence_pitch
          }}<i class="fas fa-quote-right ml-1"></i>
        </div>
        <p class="text-sm mt-3 mb-2">
          <i class="fas fa-calendar-alt mr-1"></i> Data de fundação:
          {{ formatDate(startup.foundation, "L") }}
        </p>
        <p class="text-sm mb-2" v-if="startup.bussiness_strategy">
          <i class="fas fa-users mr-1"></i> Modelo de negócio:
          {{ startup.bussiness_strategy }}
        </p>
        <p class="text-sm">
          <i class="fas fa-tags mr-1"></i> Principal setor de atuação:
          <badge type="info">{{ startup.sector }}</badge>
        </p>
      </div>
      <hr class="my-4" />
      <div>
        <div class="card-profile-image py-5">
          <img src="/img/pages/batch.png" class="rounded-circle card-image" />
        </div>

        <div class="col-12 mt-7">
          <h2 class="text-center text-warning">
            {{ batch.name }}
            <router-link :to="`/${basePage}/batches/${batch.id}/${endPage}`">
              <i class="ml-1 fas fa-eye text-sm"></i>
            </router-link>
          </h2>
          <badge type="info">{{
            batch.status === "open" ? "Regular" : "Encerrado"
          }}</badge>
        </div>
        <div class="text-sm my-3">
          <i class="fas fa-award mr-1"></i> Batch de
          <span class="text-warning">{{ batch.type }} STARS</span>
        </div>
        <p class="text-sm">
          <i class="fas fa-calendar-alt mr-1"></i> Duração:
          <span class="font-weight-light">
            {{ formatDate(batch.start_date, "L") || "..." }}
            até
            {{ formatDate(batch.end_date, "L") || "..." }}
          </span>
        </p>
        <base-button
          class="mb-3"
          type="white"
          title="'Gerenciar parcerias'"
          @click="$router.push('/startup/beneficios-aceleradas')"
          ><i class="fas fa-handshake text-success mr-2"></i> Benefícios
          aceleradas Stars</base-button
        >
      </div>
    </div>
  </card>
</template>
<script>
export default {
  name: "startup-batch-info",
  props: {
    startup: {
      type: Object,
      required: true,
      description: "Startup object",
    },
    batch: {
      type: Object,
      required: true,
      description: "Batch object",
    },
    basePage: {
      type: String,
      default: "startup",
      description: "Base page in the route to display batch info",
    },
    endPage: {
      type: String,
      default: "startups",
      description: "End page in the route to display batch info",
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 180px;
  height: 180px;
  border-radius: 10%;
  margin: auto;
}
</style>
